var _path, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEuro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 2498.1 2498.1",
    viewBox: "0 0 2498.1 2498.1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1251.4 0c689.8 1.3 1248 561.6 1246.7 1251.4s-561.6 1248-1251.4 1246.7c-688.9-1.3-1246.7-560.1-1246.7-1249 .7-690.5 561-1249.7 1251.4-1249.1z",
    fill: "#039"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    fill: "#fff",
    fontFamily: "'Arial-BoldMT'",
    fontSize: 1296,
    transform: "translate(899.0387 1749.7727)"
  }, "\u20AC")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEuro);
export default __webpack_public_path__ + "static/media/euro.a76c47fb4e4e4061fffb625d6b4a67dd.svg";
export { ForwardRef as ReactComponent };